export function omnichannelConfiguration() {
  return {
    restrict: 'E',
    template: require('./omnichannel-configuration.directive.html'),
    scope: {
      company: '<',
      organizationId: '<',
      configuration: '=',
      freshData: '<',
    },
    controller: controller,
  };
}

controller.$inject = ['$scope', 'DropdownItemsFactory', 'CrmFactory'];
function controller($scope, DropdownItemsFactory, CrmFactory) {
  if (!$scope.configuration) {
    $scope.configuration = {
      from_alcmeon_to_sf: [],
      from_sf_to_alcmeon: [],
    };
  }

  let routingTags = $scope.company.tags_groups.filter(
    (tag_group) => tag_group.is_routing === 1
  );
  $scope.routingTagsItems = DropdownItemsFactory.buildTagItems(
    routingTags
  )[0].items.flatMap((i) => i.subitems);

  $scope.availableSfQueues = $scope.freshData.available_queues.map((aq) => {
    return {
      id: aq.Id,
      label: aq.Name,
    };
  });

}
